import {i18n} from '@netx/core/i18n';

export const SearchesSavedLabel = {
	ROUTE: i18n.t('i18n.savedSearches'),
};

export const SEARCH_SAVED_ACTION_LABELS = {
	ADD_TO_CURRENT_CART: i18n.t('i18n.addAllToSelection'),
	CREATE: i18n.t('i18n.saveSearch'),
	CREATE_PDF: i18n.t('i18n.createPDF'),
	CREATE_PDF_DOWNLOAD: i18n.t('i18n.download'),
	CREATE_PDF_SHARE_LINK: i18n.t('i18n.createLink'),
	DELETE: i18n.t('i18n.deleteSearch'),
	DOWNLOAD: i18n.t('i18n.download'),
	MENU: i18n.t('i18n.share'),
	RENAME: i18n.t('i18n.rename'),
	SHARE_FEED: i18n.t('i18n.createFeed'),
	SHARE_LINK: i18n.t('i18n.createLink'),
	SHARE_TEAM_ACCESS: i18n.t('i18n.manageTeamAccess'),
	TOGGLE_FAVORITE: i18n.t('i18n.toggleFavorite'),
	VIEW: i18n.t('i18n.edit'),
};
